import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PersonAddAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"person_add_alt"}/>
}
